import { createSlice } from '@reduxjs/toolkit';



const initialState = {
     eventos :  [
        {
          id: 1,
          iconBg: "bg-blue-50",
          iconColor: "text-blue-500",
          title: "Entrevista con Elon Musk",
          date: "25 de Octubre, 2023",
          time: "10:00 AM - 11:00 AM",
          platform: "Spotify",
          dias: 15,
        },
        {
          id: 2,
          iconBg: "bg-purple-50",
          iconColor: "text-purple-500",
          title: "Charla sobre IA",
          date: "30 de Octubre, 2023",
          time: "3:00 PM - 4:00 PM",
          platform: "Apple Podcasts",
          dias: 20,
        },
        {
          id: 3,
          iconBg: "bg-green-50",
          iconColor: "text-green-500",
          title: "Debate sobre Tecnología",
          date: "5 de Noviembre, 2023",
          time: "5:00 PM - 6:00 PM",
          platform: "Google Podcasts",
          dias: 9,
        },
        {
          id: 4,
          iconBg: "bg-blue-50",
          iconColor: "text-blue-500",
          title: "Debate sobre Tecnología",
          date: "5 de Noviembre, 2023",
          time: "5:00 PM - 6:00 PM",
          platform: "Google Podcasts",
          dias: 5,
        },
      ]
};

const eventosSlice = createSlice({
  name: 'evento',
  initialState,
  reducers: {
    deleteEvents: (state, action) => {
      if (state.eventos) {
        state.eventos = state.eventos.filter(evento => evento.id !== action.payload.id )
      } 
      
    },
  },
});

export const { deleteEvents } = eventosSlice.actions;

export default eventosSlice.reducer;